/*
 * cm-research-videos — clicking a "Watch the Research" tile plays the video
 * inline in that same tile (thumbnail swapped for a YouTube-nocookie
 * iframe), matching cm-video-embed.js — no lightbox, so playing a video
 * never takes the visitor out of the page.
 */
(() => {
  document.querySelectorAll('[data-cm-research-tile]').forEach((tile) => {
    if (tile.dataset.cmResearchBound) return;
    tile.dataset.cmResearchBound = 'true';

    const play = tile.querySelector('[data-cm-research-play]');
    if (!play) return;

    play.addEventListener('click', () => {
      const id = tile.dataset.videoId;
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1`;
      iframe.title = 'Video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      tile.replaceChildren(iframe);
    });
  });
})();
